import axios from 'axios'
export default function (workingDays) {
	let source = axios.CancelToken.source();
	setTimeout(() => {
		source.cancel()
	}, 3000); // Failover after 3 seconds
	//const endpoint = 'https://www.gov.uk/bank-holidays.json';
	const endpoint = 'api/v1/bank-holidays'; // Fetch from our server which has it cached in a text file updated once per job creation
	return axios
		.get(endpoint, {cancelToken: source.token})
		.then(response => {
			let bankHolidayDates = [];
			let bankHolidays = response.data; //For ease
			let england = bankHolidays["england-and-wales"].events;
			bankHolidayDates = england.map((items) => {
				return items.date;
			});
			const now = new Date();
			const offsetMs = now.getTimezoneOffset() * 60 * 1000;
			const dateLocal = new Date(now.getTime() - offsetMs);
			var addDays = 0;
			var dayCounter = 0;
			while (dayCounter < workingDays){
				dateLocal.setDate(dateLocal.getDate()+1);
				var nextDay = dateLocal.getDay();
				var nextDateString = dateLocal.toISOString().slice(0, 10);
				if (nextDay == 0 || nextDay == 6 || bankHolidayDates.includes(nextDateString)){ // 0 == Sunday, 6 == Saturday
					addDays += 1;
				} else {
					addDays += 1;
					dayCounter += 1;
				}
			}
			return dateLocal.toISOString().slice(0, 10);
		}).catch(error => {
			// Failover to internal-only calculation
			const now = new Date();
			const offsetMs = now.getTimezoneOffset() * 60 * 1000;
			const dateLocal = new Date(now.getTime() - offsetMs);
			var addDays = 0;
			var dayCounter = 0;
			while (dayCounter < workingDays){
				dateLocal.setDate(dateLocal.getDate()+1);
				var nextDay = dateLocal.getDay();
				var nextDateString = dateLocal.toISOString().slice(0, 10);
				if (nextDay == 0 || nextDay == 6){ // 0 == Sunday, 6 == Saturday
					addDays += 1;
				} else {
					addDays += 1;
					dayCounter += 1;
				}
			}
			return dateLocal.toISOString().slice(0, 10);
		});
}
